const state = {
  deliveryInfoItemNumber: 3,
  deliveryInfoItems: [],
  currentDeliveryInfoSeq: null,
  deliveryInfoDefaultItem: null,
  selectedDeliveryInfoItem: null
}

const getters = {
  getDeliveryInfoItems: state => state.deliveryInfoItems,
  getDeliveryInfoDefaultItem: state => state.deliveryInfoDefaultItem,
  getCurrentDeliveryInfoSeq: state => state.currentDeliveryInfoSeq,
  getDeliveryInfoItemNumber: state => state.deliveryInfoItemNumber,
  getSelectedDeliveryInfoItem: state => state.selectedDeliveryInfoItem
}

const mutations = {
  setDeliveryInfoItems (state, items) {
    state.deliveryInfoItems = items
    state.deliveryInfoDefaultItem = items.find(item => parseInt(item.defFlg)) || null
  },
  setCurrentDeliveryInfoSeq (state, seq) {
    state.currentDeliveryInfoSeq = seq
  },
  setDeliveryInfoDefaultItem (state, item) {
    state.deliveryInfoDefaultItem = item
  },
  setSelectedDeliveryInfoItem (state, item) {
    state.selectedDeliveryInfoItem = item
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/yamatodeliveryinfo.js